import { BaseModel } from '../../../../../../core/_base/crud';
import { FileImport } from '../../../dung-chung/__model/file-import.model';
export class KhoXuatKho extends BaseModel {
        IdXk: number
        IdDn: number
        IdKk: number
        SoPhieuKiemKe: string
        Nguoitao: number
        TenNguoiTao: string
        Ngaytao: string
        Nguoisua: number
        Nguoixacnhan: number
        TenNguoixacnhan: string
        Ngayxacnhan: string
        Ngaysua: string
        SoPhieu: string
        LoaiPhieu: number
        DescLoaiPhieu: string
        TinhTrang: string
        DescTinhTrang: string
        IdPB: number
        BoPhanYeuCau: string
        ChiTiet: KhoXuatKhoChiTiet[]
        DSNguoiThucHien: number[]
        TenDSNguoiThucHien: string[]
        NgayXuat: string
        LyDoXuat: string
        LyDo: string
        IsEnable_Duyet: boolean
        IsVisible_Duyet: boolean
        XuatHangDiXuLy: boolean
        TenTaiXe: string
        SoXe: string
        NguoiNhanHang: string
        PhongBanNhanHang: string
        listFileChungTu: FileImport[]
        AttachmentId: number
        FileChungTu: string
        CodeLoaiPhieu: string
        NgayXacNhanXuatKhoiVTKho: string
        IdNguoiNhanHang: number
        IdPhongBanNhanHang: number
        Lydocode: string
        Lydo: string
        ChungTuKemTheo: boolean
        TenSoChungTu: DocumentInfo
        hasCancelled: boolean
        DienGiai: string
        Supplier: string
        Customer: string
        clear() {
                this.IdXk = 0;
                this.IdDn = 0;
                this.Nguoitao = 0;
                this.IdKk = 0;
                this.SoPhieuKiemKe = ""
                this.TenNguoiTao = '';
                this.Ngaytao = '';
                this.Nguoisua = 0;
                this.Nguoixacnhan = 0;
                this.TenNguoixacnhan = '';
                this.Ngayxacnhan = '';
                this.Ngaysua = '';
                this.SoPhieu = '';
                this.LoaiPhieu = 0;
                this.DescLoaiPhieu = '';
                this.TinhTrang = '';
                this.DescTinhTrang = '';
                this.IdPB = 0;
                this.BoPhanYeuCau = '';
                this.ChiTiet = [];
                this.DSNguoiThucHien = [];
                this.TenDSNguoiThucHien = [];
                this.NgayXuat = '';
                this.LyDoXuat = '';
                this.LyDo = '';
                this.IsEnable_Duyet = false;
                this.IsVisible_Duyet = false;
                this.XuatHangDiXuLy = false;
                this.TenTaiXe = ""
                this.SoXe = ""
                this.NguoiNhanHang = ""
                this.PhongBanNhanHang = ""
                this.listFileChungTu = []
                this.AttachmentId = 0
                this.FileChungTu = ""
                this.CodeLoaiPhieu = ""
                this.NgayXacNhanXuatKhoiVTKho = ''
                this.IdNguoiNhanHang = 0
                this.IdPhongBanNhanHang = 0
                this.Lydocode = ""
                this.Lydo = ""
                this.ChungTuKemTheo = true;
                this.TenSoChungTu = new DocumentInfo();
                this.hasCancelled = false;
                this.DienGiai = "";
                this.Supplier = "";
                this.Customer = ""
        }
        copy(item: KhoXuatKho) {
                this.IdXk = item.IdXk;
                this.IdDn = item.IdDn;
                this.IdKk = item.IdKk;
                this.SoPhieuKiemKe = item.SoPhieuKiemKe;
                this.Nguoitao = item.Nguoitao;
                this.TenNguoiTao = item.TenNguoiTao;
                this.Ngaytao = item.Ngaytao;
                this.Nguoisua = item.Nguoisua;
                this.Nguoixacnhan = item.Nguoixacnhan;
                this.TenNguoixacnhan = item.TenNguoixacnhan;
                this.Ngayxacnhan = item.Ngayxacnhan;
                this.Ngaysua = item.Ngaysua;
                this.SoPhieu = item.SoPhieu;
                this.LoaiPhieu = item.LoaiPhieu;
                this.DescLoaiPhieu = item.DescLoaiPhieu;
                this.TinhTrang = item.TinhTrang;
                this.DescTinhTrang = item.DescTinhTrang;
                this.IdPB = item.IdPB;
                this.BoPhanYeuCau = item.BoPhanYeuCau;
                this.ChiTiet = item.ChiTiet;
                this.DSNguoiThucHien = item.DSNguoiThucHien;
                this.TenDSNguoiThucHien = item.TenDSNguoiThucHien;
                this.NgayXuat = item.NgayXuat;
                this.LyDoXuat = item.LyDoXuat;
                this.LyDo = item.LyDo;
                this.IsEnable_Duyet = item.IsEnable_Duyet;
                this.IsVisible_Duyet = item.IsVisible_Duyet;
                this.XuatHangDiXuLy = item.XuatHangDiXuLy;
                this.TenTaiXe = item.TenTaiXe;
                this.SoXe = item.SoXe;
                this.NguoiNhanHang = item.NguoiNhanHang;
                this.PhongBanNhanHang = item.PhongBanNhanHang;
                this.listFileChungTu = item.listFileChungTu;
                this.AttachmentId = item.AttachmentId;
                this.FileChungTu = item.FileChungTu
                this.CodeLoaiPhieu = item.CodeLoaiPhieu;
                this.NgayXacNhanXuatKhoiVTKho = item.NgayXacNhanXuatKhoiVTKho
                this.IdNguoiNhanHang = item.IdNguoiNhanHang
                this.IdPhongBanNhanHang = item.IdPhongBanNhanHang
                this.Lydocode = item.Lydocode
                this.Lydo = item.Lydo
                this.ChungTuKemTheo = item.ChungTuKemTheo;
                this.TenSoChungTu = item.TenSoChungTu;
                this.hasCancelled = item.hasCancelled;
                this.DienGiai = item.DienGiai;
                this.Supplier = item.Supplier;
                this.Customer = item.Customer
        }
}
export class KhoXuatKhoChiTiet extends BaseModel {
        IdCtxk: number
        IdXk: number
        IdHh: number
        MaHH: string
        TenHH: string
        IdKho: number
        MaKho: string
        TenKho: string
        ViTriKho: string
        Soluongdn: number
        Soluongthucxuat: number
        Soluongthucnhan: number
        Tongsoluongthucnhan: number
        TiLeQuiDoi: number
        Solo: string
        Dvt: number
        DvtQuiDoi: number
        SoLuongQuiDoi: number
        TenDvt: string
        Ghichu: string
        Mucdichsudung: string
        IdLo: number
        SoPO: string
        HanSuDung: string
        QuyCach: string
        SLTon: number
        ListKho: any[]
        ListSoLo: any[]
        ListVTKho: any[]
        IdCTDN: number
        SoPhieuDNXK: string
        IdDNXK: number
        SoPhieuDHB: string
        IdPhieuDHB: number
        SLDN: number
        SLGiao: number
        isFail: boolean = false;
        isError: boolean = false;
        messageError: string;
        loaiThemHang: number; // 0 là xuất khỏi kho 1 là import 2 là xuất chuyển kho
        dateSoLo: string;
        ListSoLoChonTam: any[]
        Id_TonKhoHienTai: number[]
        NgayNhapKho: string
        IdKH: number
        MaKH: string
        TenKH: string
        DiaChi: string
        SoMay: string
        MaSub: string
        DatHangCtId: number
        FlagFIFO: boolean
        PartsUsed: string
        ListMachineCode: any[]
        ListMachineCodeSelected: any[]
        NotesExport: string
        TagInfo: any[]
        ListIdInvTemp: any[]
        reqMachine: string
        DienGiaiMaster: string
        NgaySanXuat: string
        MaThung: string
        SoMeSoXe: string
        Pallet: string
        SupplierCode: string
        SupplierName: string
        SupplierAddress: string
        Receiver: string
        AddressReceiveProduct: string
        Reason: string
        CustomerPurchaseOrder: string
        UsingDeparmentId: number
        UsingDivisionId: number
        IsCheckboxDisabled: boolean
        SoLoYeuCau: string
        clear() {
                this.IdCtxk = 0;
                this.IdXk = 0;
                this.IdHh = 0;
                this.MaHH = '';
                this.TenHH = '';
                this.IdKho = 0;
                this.MaKho = '';
                this.TenKho = '';
                this.ViTriKho = '';
                this.TiLeQuiDoi = 0;
                this.Soluongdn = 0;
                this.Soluongthucxuat = 0;
                this.Soluongthucnhan = 0;
                this.Tongsoluongthucnhan = 0;
                this.Solo = '';
                this.Dvt = 0;
                this.TenDvt = '';
                this.DvtQuiDoi = 0;
                this.SoLuongQuiDoi = 0;
                this.Ghichu = '';
                this.Mucdichsudung = '';
                this.IdLo = 0;
                this.SoPO = '';
                this.HanSuDung = '';
                this.QuyCach = '';
                this.SLTon = 0;
                this.ListKho = [];
                this.ListSoLo = [];
                this.ListVTKho = [];
                this.IdCTDN = 0;
                this.SoPhieuDNXK = '';
                this.SoPhieuDHB = '';
                this.IdPhieuDHB = 0;
                this.SLDN = 0;
                this.SLGiao = 0;
                this.isFail = false;
                this.isError = false;
                this.messageError = '';
                this.loaiThemHang = 0;
                this.dateSoLo = '';
                this.ListSoLoChonTam = [];
                this.Id_TonKhoHienTai = [];
                this.NgayNhapKho = null;
                this.IdKH = 0;
                this.MaKH = '';
                this.TenKH = '';
                this.DiaChi = '';
                this.SoMay = '';
                this.MaSub = '';
                this.DatHangCtId = 0;
                this.IdDNXK = 0;
                this.FlagFIFO = true;
                this.PartsUsed = "";
                this.ListMachineCode = []
                this.ListMachineCodeSelected = []
                this.NotesExport = ''
                this.TagInfo = []
                this.ListIdInvTemp = []
                this.reqMachine = ""
                this.DienGiaiMaster = ""
                this.NgaySanXuat = ""
                this.MaThung = ""
                this.SoMeSoXe = ""
                this.Pallet = ""
                this.SupplierCode = ""
                this.SupplierName = ""
                this.SupplierAddress = ""
                this.Receiver = ""
                this.AddressReceiveProduct = ""
                this.Reason = "";
                this.CustomerPurchaseOrder = ""
                this.UsingDeparmentId = 0
                this.UsingDivisionId = 0
                this.IsCheckboxDisabled = false
                this.SoLoYeuCau = ""
        }
}
export class KhoXuatKhoDeNghi extends BaseModel {
        IdHH: number
        MaHH: string
        TenHH: string
        QuyCach: string
        Dvt: number
        TenDvt: string
        SoLuong: number
        DvtQuiDoi: number
        SoLuongQuiDoi: number
        TiLeQuiDoi: number
        MucDichSuDung: string
        NgayCan: string
        GhiChu: string
        IdPhieuDNXK: number
        SoPhieuDNXK: string
        NgayLapPhieuDNXK: string
        TinhTrang: string
        SLTon: number
        dsKho: any[]
        IdCtDn: number
        IdPhieuDHB: number
        SoLuongThucXuat: number
        SoPhieuDHB: string
        DatHangCtId: number
        LoaiPhieu: string
        IdKH: number
        MaKH: string
        TenKH: string
        DiaChi: string
        IdDNXK: number
        IdKhoDefault: number
        IdPBDN: number
        TenPBDN: string
        IdKhuVuc: number
        TenKhuVuc: string
        isShow: boolean
        PartsUsed: string
        ReqMachine: string
        AttachedDocuments: string
        CustomerPurchaseOrder: string
        SupplierCode: string
        SupplierName: string
        SupplierAddress: string
        Receiver: string
        AddressReceiveProduct: string
        Reason: string
        UsingDeparmentId : number
        UsingDivisionId: number
        IsCheckboxDisabled: boolean
        SoLoYeuCau: string
        clear() {
                this.IdHH = 0;
                this.MaHH = '';
                this.TenHH = '';
                this.QuyCach = '';
                this.Dvt = 0;
                this.DvtQuiDoi = 0;
                this.SoLuongQuiDoi = 0;
                this.TiLeQuiDoi = 0;
                this.TenDvt = '';
                this.SoLuong = 0;
                this.MucDichSuDung = '';
                this.NgayCan = '';
                this.GhiChu = '';
                this.IdPhieuDNXK = 0;
                this.SoPhieuDNXK = '';
                this.NgayLapPhieuDNXK = '';
                this.TinhTrang = '';
                this.SLTon = 0;
                this.dsKho = [];
                this.IdCtDn = 0;
                this.IdPhieuDHB = 0;
                this.SoLuongThucXuat = 0;
                this.LoaiPhieu = '';
                this.SoPhieuDHB = ""
                this.DatHangCtId = 0
                this.IdKH = 0;
                this.MaKH = ""
                this.TenKH = ""
                this.IdDNXK = 0;
                this.IdKhoDefault = null;
                this.DiaChi = "";
                this.IdPBDN = 0
                this.TenPBDN = ""
                this.IdKhuVuc = 0
                this.TenKhuVuc = ""
                this.isShow = false
                this.PartsUsed = ""
                this.ReqMachine = ""
                this.CustomerPurchaseOrder = ""
                this.SupplierCode = ""
                this.SupplierName = ""
                this.SupplierAddress = ""
                this.Receiver = ""
                this.AddressReceiveProduct = ""
                this.Reason = ""
                this.UsingDeparmentId = 0
                this.UsingDivisionId = 0
                this.IsCheckboxDisabled = false
                this.SoLoYeuCau = ""
        }
        copy(item: KhoXuatKhoDeNghi) {
                this.IdHH = item.IdHH;
                this.MaHH = item.MaHH;
                this.TenHH = item.TenHH;
                this.QuyCach = item.QuyCach;
                this.Dvt = item.Dvt;
                this.TenDvt = item.TenDvt;
                this.DvtQuiDoi = item.DvtQuiDoi;
                this.SoLuongQuiDoi = item.SoLuongQuiDoi;
                this.TiLeQuiDoi = item.TiLeQuiDoi;
                this.SoLuong = item.SoLuong;
                this.MucDichSuDung = item.MucDichSuDung;
                this.NgayCan = item.NgayCan;
                this.GhiChu = item.GhiChu;
                this.IdPhieuDNXK = item.IdPhieuDNXK;
                this.SoPhieuDNXK = item.SoPhieuDNXK;
                this.NgayLapPhieuDNXK = item.NgayLapPhieuDNXK;
                this.TinhTrang = item.TinhTrang;
                this.SLTon = item.SLTon;
                this.dsKho = item.dsKho;
                this.IdCtDn = item.IdCtDn;
                this.IdPhieuDHB = item.IdPhieuDHB;
                this.SoLuongThucXuat = item.SoLuongThucXuat;
                this.LoaiPhieu = item.LoaiPhieu;
                this.SoPhieuDHB = item.SoPhieuDHB;
                this.DatHangCtId = item.DatHangCtId;
                this.MaKH = item.MaKH
                this.TenKH = item.TenKH
                this.IdDNXK = item.IdDNXK
                this.IdKhoDefault = item.IdKhoDefault
                this.IdKH = item.IdKH
                this.DiaChi = item.DiaChi
                this.IdPBDN = item.IdPBDN
                this.TenPBDN = item.TenPBDN
                this.IdKhuVuc = item.IdKhuVuc
                this.TenKhuVuc = item.TenKhuVuc
                this.isShow = item.isShow
                this.PartsUsed = item.PartsUsed
                this.ReqMachine = item.ReqMachine,
                this.AttachedDocuments = item.AttachedDocuments
                this.CustomerPurchaseOrder = item.CustomerPurchaseOrder
                this.SupplierCode = item.SupplierCode
                this.SupplierName = item.SupplierName
                this.SupplierAddress = item.SupplierAddress
                this.Receiver = item.Receiver
                this.AddressReceiveProduct = item.AddressReceiveProduct
                this.Reason = item.Reason
                this.UsingDeparmentId = item.UsingDeparmentId
                this.UsingDivisionId = item.UsingDivisionId
                this.IsCheckboxDisabled = item.IsCheckboxDisabled
                this.SoLoYeuCau = item.SoLoYeuCau
        }
}
export class ExportPrinter {
        static companyName = "CÔNG TY TNHH THỰC PHẨM NFC";
        static companyAddress = "Đường số 8, KCN Nhơn Trạch I, Xã Phước Thiền, Huyện Nhơn Trạch, Tỉnh Đồng Nai, Việt Nam";
        static title = "PHIẾU XUẤT KHO";
        static subTitle1 = "Nợ: ";
        static subTitle2 = "Số: ";
        static subTitle3 = "Còn: ";
        static receiverName = "- Họ và tên người nhận hàng: ";
        static receiverAddress = "- Địa chỉ (bộ phận): ";
        static contentReason = "- Lý do xuất: ";
        static contentPosition = "- Xuất tại kho (ngăn lô):"
        static contentLocation = "Địa điểm: ";
        static textTotalMoney = "- Số tiền bằng chữ: ";
        static originalDocuments = "- Số chứng từ gốc kèm theo: ";
        static dateMonthYear = "Ngày.......tháng.......năm.......";
        static signAndFullName = "(Ký, họ tên)"
        static creator = "Người lập phiếu";
        static reciver = "Người nhận hàng";
        static deliver = "Người giao hàng";
        static manager = "Quản lý kho";
        static warehouseKeeper = "Thủ kho";
        static chiefAccountant = "Kế toán trưởng";
        static president = "Giám đốc";
        static signDefault = "NGUYỄN THANH HOÀNG";
}
export class DocumentInfo extends BaseModel {
        Name: string
        RequestId: number
        clear() { this.Name = "", this.RequestId = 0 };
        copy(item: DocumentInfo) { this.RequestId = item.RequestId, this.Name = item.Name };
        DocumentInfo() { this.Name = ""; this.RequestId = 0 }
}
export class ConstantsExport {
        // .. Loại phiếu
        public static readonly INTERNAL_EXPORT           = 'XK_XUATNOIBO';
        public static readonly EXPORT_FOR_SELL           = 'XK_XUATBANHANG';
        public static readonly EXPORT_PRODUCT_TO_OUTSIDE = 'XK_XUATRANGOAI';
        // .. Lý do xuất
        public static readonly EXPORT_SUPPLIER_RETURN    = "XUATTRANCC";
        public static readonly OTHER_REASON              = "KHAC";
        public static readonly EXPORT_PRODUCT_BY_REQUEST = "THEOPHIEUDN";
        public static readonly REASON_EXPORT_FOR_SELL    = 'XUATBH';
        // .. Tab Đề nghị xuất kho
        public static readonly TAB_INTERNAL_EXPORT       = 0;
        public static readonly TAB_SELL_EXPORT           = 1;
        public static readonly TAB_SUPPLIER_EXPORT       = 2;
        // .. Lock đề nghị xuất kho
        public static readonly LOCK_REQXUATKHO          = "LOCK_REQXUATKHO";
}
